<section>
  <div class="close" [mat-dialog-close]>
    <img src="../../assets/close-icon.svg" alt="" />
  </div>
  <div class="header">
    <h1>Upload Payment Evidence</h1>
    <p>
      Image upload should not be more than 860 x 860 px in jpeg or png format
    </p>
  </div>
  <div class="center">
    <ngx-file-drop
      dropZoneLabel="Drop files here"
      (onFileDrop)="dropped($event)"
      dropZoneClassName="file-drop"
    >
      <ng-template
        ngx-file-drop-content-tmp
        let-openFileSelector="openFileSelector"
      >
        <div class="up">
          <img src="../../assets/upload-icon.svg" alt="upload icon" />
          <div style="color: #000; font-weight: bold; font-size: 1.3em">
            Drap and Drop image file to upload.
          </div>
          <button
            style="margin-top: 3em"
            color="warn"
            mat-stroked-button
            type="button"
            (click)="openFileSelector()"
          >
            Select a File
          </button>
        </div>
      </ng-template>
      
    </ngx-file-drop>

    <div *ngIf="fileName" class="upload-table">
      <table class="table">
        <thead>
          <tr>
            <th style="color: #ff5733;">Uploaded:</th>
          </tr>
        </thead>
        <tbody class="upload-name-style">
          <tr *ngFor="let item of files; let i = index">
            <td>
              <strong>{{ item.relativePath }}</strong>
            </td>
          </tr>
        </tbody>
      </table>
      <button
      (click)="saveUpload()"
        style="margin-top: 3em"
        color="warn"
        mat-stroked-button
        type="button">
        Save
      </button>
    </div>
  </div>
</section>
